"use client";

// npm packages
import classNames from 'classnames';
import { useRouter } from 'next/navigation';

// components
import Icon from '../Icon';
import Text from '../Text';

// utils

const GoBack = ({
  children,
  className = '',
  iconColor,
  iconSize,
  upperCase = false,
  disabled = false,
  ...rest
}) => {
  const router = useRouter();

  return (
    <button
      className="flex items-center gap-[4px] pt-20 cursor-pointer mb-10 sm:mb-20"
      onClick={() => router.back()}
      {...rest}
    >
      <Icon
        type="arrow-left"
        // height="16"
        // width="16"
        color={iconColor || "#28313C"}
        className="size-[16px] sm:size-[24px]"
      />
      <Text
        type="paragraph"
        className="text-12 sm:text-16 text-coarse-wool !font-encode-sans font-bold leading-14 sm:leading-20 tracking-[0.24px] sm:tracking-[0.32px] "
      >
        Go Back
      </Text>
    </button>
  );
};

export default GoBack;
